import {StyleSheet} from 'react-native';

import {white} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {
    flex: 1,
    backgroundColor: white,
  },
  content: {
    flex: 1,
    backgroundColor: white,
  },
  scrollViewContainer: {
    flexGrow: 1,
    marginBottom: 180,
    justifyContent: 'center',
  },
  contentLoading: {
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: white,
  },
  sections: {
    paddingBottom: 60,
  },
});
